import { CartContext } from '../../../features/cartContext/CartContext'
import { useContext } from 'react'
import { useGetNotesQuery } from '../../../features/notes/notesApiSlice';

const ShoppingCart = (props) => {

    const cart = useContext(CartContext)


    // console.log(window.location.href ==="http://localhost:3001/OnlineOrdering/cart")

    const { id, subTotal, setSubTotal } = props;

    const {
        data: notes,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetNotesQuery('notesList', {
        pollingInterval: 60000,
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    let content
    let content_mod
    let content_one

    if (isLoading) content = <p>Loading...</p>

    if (isError) {
        content = <div style={{ color: "red" }}>Loading...</div>
    }

    if (isSuccess) {

        const { ids } = notes

        const dataResponse = ids.map((val) => {
            return notes.entities[val]
        })

        var productsData = Object.keys(dataResponse).map(key => {
            return dataResponse[key];
        })

        productsData = (productsData.filter((currentProduct) => {
            return currentProduct._id === id
        }
        ))[0]

        // console.log(productsData)

        const product = cart.items.filter(val => { return val.id === id })[0]

        // console.log(product)

        // console.log(productsData.fPrice)

        // console.log(cart.getTotalCost(parseFloat(price)))

        const quantity = product.quantity
        var price = productsData.fPrice

        // console.log(productsData)

        content = (
            <div>
                <div className="mx-auto  w-full justify-center px-6 md:flex md:space-x-6 xl:px-0 border-b-2 border-slate-200 .">
                    <div className="rounded-xs md:w-full">
                        <div className="justify-between gap-2 mb-2 rounded-lg bg-white py-1 shadow-xs sm:flex sm:justify-start">
                            <div >
                                <img
                                    src={`${productsData.fPicName}`}
                                    alt="product-image" className="size-20 rounded-md object-cover" />
                            </div>
                            <div className="sm:ml-0 sm:flex sm:w-full sm:justify-between">

                                <div className="mt-5 sm:mt-0">
                                    <h2 className="text-lg font-bold text-gray-900">{productsData.title}  </h2>
                                    <p className="mt-1 text-xs text-gray-700">{productsData.text}</p>
                                    <p className="text-sm font-normal ">${parseFloat(price).toFixed(2)} </p>
                                </div>
                                <div className="mt-4 flex justify-between sm:space-y-6 sm:mt-0 sm:block sm:space-x-6 ">
                                    <div className="flex items-center border-gray-100">
                                        <span onClick={() => cart.removeOneFromCart(product.id)} className="cursor-pointer rounded-l bg-gray-100 py-1 px-3.5 duration-100 hover:bg-blue-500 hover:text-blue-50"> - </span>
                                        {/* <p>{quantity}</p> */}
                                        <input className="h-8 w-8 border bg-white text-center text-xs outline-none" type="number" value={quantity} min="1" />
                                        <span onClick={() => cart.addOneToCart(productsData)} className="cursor-pointer rounded-r bg-gray-100 py-1 px-3 duration-100 hover:bg-blue-500 hover:text-blue-50"> + </span>
                                    </div>
                                    <div className="flex justify-between  space-x-4">
                                        <p className="text-sm">${(cart.getTotalCost(price, id)).toFixed(2)}</p>
                                        <svg onClick={() => cart.deleteFromCart(product.id)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 cursor-pointer duration-150 hover:text-red-500">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return content

}

export default ShoppingCart